export default __webpack_public_path__ + "static/media/stripped-sour-featured-image.37831387.png";